'use strict'

function initializeVtsHeader() {
  // Wait until the DOM is ready
  $(document).ready(function () {
    // Get the mobile header element
    const mobileMenu = document.querySelector('.vts-header__mobile')
    if (mobileMenu) {
      // Get the mobile menu button
      document.querySelector('.vts-header__pointer').addEventListener('click', openMenu)
      // Get the mobile menu close button
      document.querySelector('#vts-header-close').addEventListener('click', closeMenu)
    }

    /**
     * Open the mobile menu
     */
    function openMenu() {
      mobileMenu.classList.add('vts-header__mobile--open')
      // Listen for the ESC key to close the menu while it is open
      document.addEventListener('keydown', closeMenuOnEsc)
    }

    /**
     * Close the mobile menu
     */
    function closeMenu() {
      mobileMenu.classList.remove('vts-header__mobile--open')
      // Remove the ESC key listener
      document.removeEventListener('keydown', closeMenuOnEsc)
    }

    /**
     * Close the mobile menu when the ESC key is pressed
     *
     * @param {object} event - The keydown event
     */
    function closeMenuOnEsc(event) {
      if (event.key === 'Escape') {
        closeMenu()
      }
    }

    // Listen for clicks on the document, so we can close the menu if the user
    // clicks outside of it
    document.addEventListener('click', function (ev) {
      if (mobileMenu) {
        // If the user clicks on the mobile menu, do nothing
        if (!mobileMenu.classList.contains('vts-header__mobile--open')) {
          return
        }
        // If the user clicks inside the mobile menu, do nothing
        if (ev.target.closest('.vts-header__mobile') || ev.target.closest('.vts-header__pointer')) {
          return
        }
        // Otherwise, close the menu
        if (ev.target.closest('.vts-header__mobile') === null) {
          closeMenu()
        }
      }
    })
  })
}

export default initializeVtsHeader
